$(document).ready(function() {
    // https://github.com/Supplyframe/fragments v1.2.8
    $('input[type="checkbox"][data-toggle]').each(function() {
        let $input = $(this);
        let size = $input.attr('data-toggle') == 'large' ? 'large' : '';
        let $container = $(`<div class="toggle-wrapper ${size}"><div class="toggle"><div class="nub-wrapper"><span class="nub"></span></div></div></div>`);
    
        $container.insertBefore($input);
        $input.prependTo($container);
        $container.on('click', (e) => {
            e.preventDefault();
            if (!$input.prop('disabled')) {
                $input.prop('checked', !$input.prop('checked'));
                $input.trigger('change');
            }
        });
    });
});